<script>
	import AJ404 from '$lib/components/global/icons/AJ404.svelte';
</script>

<section class="grid content-start grid-cols-1 gap-10 p-4 text-center justify-items-center">
	<AJ404 />
	<h1 class="text-5xl lg:text-6xl">Uh oh, that page doesn&apos;t seem to exist.</h1>
	<h2 class="font-sans text-4xl lg:text-5xl">
		Were you looking for{' '}
		<a href="/courses" class="link"> Courses </a>
	</h2>
</section>
